import { Outlet, useOutletContext } from 'react-router-dom'

import type { RouteContext } from 'modules/employees/lib/types'
import CollectionsBootstrap from 'modules/tasks/lib/CollectionsBootstrap'

const Container = () => {
  const context = useOutletContext<RouteContext>()

  return <Outlet context={context} />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
